<template>
	<div>
<!--		<b-button class="btn_add_person">{{ $t('VideoPrivacy.exportAllButtonText') }}</b-button>-->
		<b-button @click="addPerson" class="btn_add_record">{{ $t('VideoPrivacy.addPersonButtonText') }}</b-button>
		<table>
			<tr>
				<th class="large">
					<button id="btn_name" class="sorting active" @click="sort('name')">{{
							$t('VideoPrivacy.nameColumn')
						}}
					</button>
				</th>
				<th class="large">
					<button id="btn_email_address" class="sorting" @click="sort('email_address')">
						{{ $t('VideoPrivacy.mailColumn') }}
					</button>
				</th>
				<th>
					<button id="btn_date_row" class="sorting" @click="sort('date_row')">{{
							$t('VideoPrivacy.date')
						}}
					</button>
				</th>
				<th>
					<button id="btn_thematic" class="sorting" @click="sort('thematic')">{{
							$t('VideoPrivacy.thematic')
						}}
					</button>
				</th>
			</tr>
			<tr v-for="record in this.records" :key="record.date">
				<td>{{ record.name }}</td>
				<td>{{ record.email_address }}</td>
				<td>{{ record.date_human }}</td>
				<td>{{ record.thematic }}</td>
				<td class="control">
					<b-button @click="downloadAgreement(record.id)" class="btn-export">
						{{ $t('VideoPrivacy.consultDocument') }}
					</b-button>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import Navbar from "@/components/ui/Navbar";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

export default {
	components: {Navbar},
	name: "ImageRightsRecords",
	data() {
		return {
			languages: [
				{flag: "static/images/flags/fr.svg", language: "fr", title: "Français"},
				{flag: "static/images/flags/en.svg", language: "en", title: "English"},
			],
			records: [],
			sorting_attr: "name",
			sorting_order: 1,
		};
	},
	created() {
		this.getRecords();
		let $this = this;
		EventBus.$on("setLanguage", lang => {
			$this.$root.$i18n.locale = lang;
		});
	},
	methods: {
		sort(key) {
			if (this.sorting_attr === key) { // if already sorting on this key, reverse order
				this.sorting_order = -this.sorting_order;
			} else {
				this.sorting_attr = key;
			}
			this.sortData();

			this.updateHeaders();
		},
		sortData() {
			let $attr = this.sorting_attr;
			let $order = this.sorting_order;

			this.records.sort(function (a, b) {
				let val1 = a[$attr].toString();
				let val2 = b[$attr].toString();
				if (val1 < val2) {
					return -$order;
				}
				if (val1 > val2) {
					return $order;
				}
				return 0;
			});
		},
		formatDate(dateString) {
			// Formats a date into this format: DD/MM/YY
			let date = new Date(dateString);
			let day = ("0" + date.getDate()).slice(-2);
			let month = ("0" + (date.getMonth() + 1)).slice(-2);
			let year = date.getFullYear().toString().slice(-2);

			return day + "/" + month + "/" + year;
		},
		updateHeaders() {
			let headers = document.getElementsByClassName("sorting");
			let i;
			for (i = 0; i < headers.length; i++) {
				headers[i].classList.remove("active");
			}

			let header = document.getElementById("btn_" + this.sorting_attr);
			header.classList.add("active");
		},
		getRecords() {
			let $this = this;
			let datas = [];
			// Absolute url because this service isn't integrated to the rest of the API
			axios.get("https://api.enjoyb.fr/agreements/", {
				params: {
					company_name: process.env.VUE_APP_CLIENT,
					referent_email_address: sessionStorage.getItem("usermail"),
				},
			})
			.then(function (response) {
				let records = response.data.agreements;
				records.forEach(function (record) {
					datas.push({
						id: record.id,
						name: record.name,
						email_address: record.email_address,
						date_row: record.filming_date,
						date_human: $this.formatDate(record.filming_date),
						thematic: record.thematic,
					});
				});
				$this.records = datas;
				$this.sortData();
			}).catch(error => {
				$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, "
					+ "et veuillez nous excuser pour la gêne occasionnée.\nErreur : " + error.response;
				$this.$refs.modalError.show();
			});
		},
		addPerson() {
			this.$router.push({name: "ImageRightsAgreement"});
		},
		goToAgreement(agreement) {
			this.$router.push({
				name: "ImageRightsAgreement",
				query: {company_name: process.env.VUE_APP_CLIENT, id: agreement.id},
			});
		},
		downloadAgreement(agreement_id) {
			const link = document.createElement("a");
			link.href = ("https://api.enjoyb.fr/agreements/" + agreement_id
					+ "?company_name=" + process.env.VUE_APP_CLIENT
					+ "&referent_email_address=" + sessionStorage.getItem("usermail"));
			link.setAttribute("download", ""); // or any other extension
			document.body.appendChild(link);
			link.click();
		},
	},
	computed: {
		recordsByName() {
			let array = this.records.slice();
			return array.reverse();
		},
	},
};
</script>

<style scoped>
table {
	margin: 20px 0 0;
	font-weight: bold;
}

.large {
	width: 407px;
}

.active {

}

.control {
	border: none;
}

.control button {
	background: var(--color-validation);
	border-color: var(--color-validation);
	border-radius: var(--small-border-radius);
	color: var(--text-validation);
	font-size: 12px;
	padding: 2px 8px;
	margin: 0;
}

.control button:hover {
	background: #53565A;
	border-color: #53565A;
	color: white;
	font-size: 12px;
	padding: 2px 8px;
	margin: 0;
}

td {
	padding: 10px 15px;
	color: #224B93;
}

th button {
	opacity: 0.5;
	padding: 10px;
	margin: 0;
	color: #224B93;
	background: none;
	border: 0;
	cursor: pointer;
	font-weight: bold;
}

th button.active {
	opacity: 1;
}

.btn_add_record {
	color: var(--text-validation);
	background: var(--color-validation);
	border-color: var(--color-validation);
	border-radius: var(--small-border-radius);
	padding: 10px 15px;
	margin: 20px 0;
}

.btn_add_person {
	color: #FFFFFF;
	background: #27509B;
	border-color: #27509B;
	border-radius: 0;
	padding: 10px 15px;
	margin: 20px 0;
}

.btn_add_record:hover {
	color: white;
	background: #53565A;
	border-color: #53565A;
	border-radius: 0;
	padding: 10px 15px;
	margin: 20px 0;
}

.btn_add_person:hover {
	color: white;
	background: #53565A;
	border-color: #53565A;
	border-radius: 0;
	padding: 10px 15px;
	margin: 20px 0;
}

.btn-export {
	width: 150px;
	border-radius: 0;
}

td {
	border: 1px solid #224B93;
}
</style>
